import en from '@hkm/features/app/pages/initializationError/i18n/en.json';

const translations = en.PAGES.INITIALIZATION_ERROR;

export function renderStartupFailure(): void {
  const root = document.getElementById('root');

  if (!root) {
    return;
  }

  const container = document.createElement('div');
  const header = document.createElement('p');
  const description = document.createElement('p');
  const button = document.createElement('button');

  container.setAttribute('role', 'alert');
  header.textContent = translations.HEADER;
  description.textContent = translations.SUBHEADER;
  button.type = 'button';
  button.textContent = translations.TRY_AGAIN;
  button.addEventListener('click', () => window.location.reload());

  container.append(header, description, button);
  root.replaceChildren(container);
}
